export default "__VITE_ASSET__jkXcBTLd__"